import { ACTIONS } from "../../Models/ENUM";
import ARRAY from "../../UTIL/ARRAY";
import DATE from "../../UTIL/DATE";
import CONQUER from "../CONQUER";

class Analytics
{
    private conquer     : CONQUER;
    private vars        : any = {};

    constructor( conquer:CONQUER )
    {
        this.conquer = conquer;
    };

    public setPayload( object:any )
    {
        this.vars = object;
    };

    public async get( vars:any ) : Promise<any>
    {
        let values = await this.conquer.do( ACTIONS.ANALYTICS_GET, vars );
        return Promise.resolve( values );
    }

    public set( label:string, value?:any )
    {
        return;
        this.conquer.do( ACTIONS.ANALYTICS_SET, ARRAY.extract( this.vars, { label:label, value:value } ) )
    }

    public async onEntryPoint()
    {

        var os = "";
        var browser = "";
        var ip = "";
        var domain = "";

        if (typeof window != 'undefined')
        {
            domain = window.location.origin;
        }

        // ADD: country, time, browser, os, platform, everything
        if (typeof navigator != 'undefined')
        {
            var userAgent = navigator.userAgent;

            if (userAgent.indexOf('X11') >= 0) os = "Unix";
            if (userAgent.indexOf('CrOS') >= 0) os = "ChromeOS";
            if (userAgent.indexOf('Android') >= 0) os = "Android";

            if (userAgent.indexOf('Windows NT') >= 0) os = "Windows";

            if (userAgent.indexOf('Macintosh') >= 0) os = "MacOS";

            if (userAgent.indexOf('iOS') >= 0) os = "iOS";
            if (userAgent.indexOf('iPhone') >= 0) os = "iPhone";
            if (userAgent.indexOf('iPad') >= 0) os = "iPad";
            
            if (os == "") os = "unknown";


            if (userAgent.match(/Edge\/[0-9.]*$/g)) browser = "Edge";
            if (userAgent.match(/Safari\/[0-9.]*$/g)) browser = "Safari";
            if (userAgent.match(/OPR\/[0-9.]*$/g)) browser = "Opera";
            if (userAgent.match(/Firefox\/[0-9.]*$/g)) browser = "Firefox";
            if (navigator.vendor.indexOf('Google') >= 0) browser = "Chrome";
            if (browser == "") os = "unknown";

            const xhrIP = new XMLHttpRequest();
            const urlIP = 'https://api.ipify.org/?format=json';
            xhrIP.open('GET', urlIP, true);
            await new Promise<void>((resolve, reject) => {
                xhrIP.onload = () => {
                    ip = xhrIP.responseText;
                    resolve();
                };
                xhrIP.send();
            });

            try {
                ip = JSON.parse(ip).ip;
            } catch (e) {
                ip = "undefined"
            }
        }

        let vars = { label:"onEntryPoint", ip: ip, browser: browser, os: os, domain: domain };

        this.conquer.do( ACTIONS.ANALYTICS_SET, ARRAY.extract( this.vars, vars ) )
    }
 
};

export default Analytics;